import styled from "styled-components";

export const StyledRoutesExceptHeader = styled.main`
  display: flex;
  flex-direction: column;
  height: calc(100% - 70px);
  width: 100%;
  box-sizing: border-box;
  padding: 2rem;
`;
